import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { TriggerButton, TriggerIcon, TriggerText, TriggerWrapper } from '../ScheduleCallback/styled-components'
import IconCarbonCatalog from '@/shared/icons/IconCarbonCatalog'

const MiniGuide = () => {
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)
  if (country !== 'fr') {
    return null
  }

  return (
    <TriggerWrapper>
      <TriggerButton onClick={() => window.open(t('subscriptionForm:mini_guide.link'), '_blank')}>
        <TriggerIcon data-role='trigger-icon'>
          <IconCarbonCatalog size={16} />
        </TriggerIcon>
        <TriggerText>{t('subscriptionForm:mini_guide.title')}</TriggerText>
      </TriggerButton>
    </TriggerWrapper>
  )
}

export default MiniGuide
